/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Upload_IncompleteInputs */

const en_error_upload_incomplete = /** @type {(inputs: Error_Upload_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The upload was interrupted: try again.`)
};

/**
* | output |
* | --- |
* | "The upload was interrupted: try again." |
*
* @param {Error_Upload_IncompleteInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_upload_incomplete = /** @type {((inputs?: Error_Upload_IncompleteInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Upload_IncompleteInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_upload_incomplete(inputs)
});